
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/case-study/property2x",
      function () {
        return require("private-next-pages/case-study/property2x.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/case-study/property2x"])
      });
    }
  